// extracted by mini-css-extract-plugin
module.exports = {"updateFailedError":"_1LTVgO40rRVBh2rMQG-IPx"};